import { Col, FormFeedback, FormGroup, Input, Label } from 'reactstrap';

import classNames from 'classnames';
import { get } from 'radash';

import { s } from 'utilities/strings';

import { useOrderTypeConfiguration } from './hooks';

const ReadOnlyShop = () => {
  const { displayValue, errors } = useOrderTypeConfiguration();

  return (
    <FormGroup row>
      <Label sm={4}>{s('Site.OrderType')}</Label>
      <Col sm={8}>
        <Input
          className={classNames({
            'is-invalid': get(errors, 'orderTypeId.type') === 'custom',
          })}
          placeholder={s(['Site.Not', 'Site.Set'])}
          plaintext={true}
          readOnly={true}
          type="text"
          value={displayValue}
        />
        <FormFeedback type="invalid">{get(errors, 'orderTypeId.message')}</FormFeedback>
      </Col>
    </FormGroup>
  );
};

export default ReadOnlyShop;
